import {Injectable} from '@angular/core';
import {SegmentedMessage} from "sms-segments-calculator";
import emojiRegex from "emoji-regex";
import {ToastService} from "./toast.service";

const regex = emojiRegex();

@Injectable({
  providedIn: 'root',
})

export class HelperService {
  constructor(
    private _toastService : ToastService
  ) {
  }

  static preventInvalidNumbers(event: any): void {
    const keyPressed = event.key;
    const keyCode = keyPressed.charCodeAt(0);
    if (keyCode === 66 || keyCode === 65 || keyCode === 84 || keyCode === 67) {
      return;
    }
    const regex = /^[0-9.+,]+$/;
    if (keyCode === 118) {
      return;
    }
    if (!regex.test(keyPressed)) {
      event.preventDefault();
    }
  }


  static preventInvalidQuantity(event: any): void {
    const keyPressed = event.key;
    const keyCode = keyPressed.charCodeAt(0);
    if (keyCode === 66 || keyCode === 65) {
      return;
    }
    const regex = /^[0-9]+$/;
    if (keyCode === 118) {
      return;
    }
    if (!regex.test(keyPressed)) {
      event.preventDefault();
    }
  }

  static unicodeToRendered(text) {
    return text.replace(/\\u(\w{4})/g, (match, hex) => String.fromCharCode(parseInt(hex, 16)));
  }


  static renderedToUnicode(text): any {
    // @ts-ignore
    return Array.from(text).map(char => "\\u" + char.charCodeAt(0).toString(16).padStart(4, "0")).join("");
  }

  static parseTextForEmoji(message) {
    return message.replace(/\r\n/g, "\n").replace(regex, '');
  }

  private SmsCounter() {
  }

   copyToClipboard(el: HTMLInputElement): void {
    if (el.value === '' || el.value === '0') {
      return;
    }
    el.select();
    document.execCommand('copy');
    el.setSelectionRange(0, 0);
    this._toastService.toast('Copied successfully','success').then()
    // NotificationsService.notify('Kopieret til udklipsholderen', 'info', 'top');
  }


  static smsParser(message: string) {
    message = this.parseTextForEmoji(message)

    let segmentedMessage = new SegmentedMessage(message, 'auto', true);
    let converted = segmentedMessage.graphemes.join("");
    let nonGsm = segmentedMessage.getNonGsmCharacters();

    if (nonGsm.length > 0) {
      nonGsm.forEach((i) => {
        // @ts-ignore
        converted = converted.replace(`${i}`, '')
        // converted = converted.replace('\n', '');
      })
    }

    segmentedMessage = new SegmentedMessage(converted, 'GSM-7', true);

    return {
      'text': converted,
      'length': segmentedMessage.numberOfCharacters,
      'parts': segmentedMessage.segments.length
    }
  }

}
